<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-12">
				<div class="d-flex flex-wrap flex-wrap align-items-center justify-content-center">
                    <div class="text-center">
                        <h4 class="mb-3">카테고리심층분석</h4>
                        <p class="mb-0">키워드를 입력하면 관련 카테고리의 상세 분석 정보를 제공합니다.<br> 최소/최대/평균가격, 평균조회수, 평균리뷰수, 예상매출 등을 확인할 수 있습니다.&nbsp;&nbsp;&nbsp;&nbsp;<span v-b-modal.modal-3 variant="link" class="mb-0"><u>수집이 잘 되지 않는 경우 조치방법</u></span></p>
							<b-modal id="modal-3" size="sm" title="수집이 잘 되지 않는 경우 조치방법" ok-only>
								<p v-for="(tip, i) in collectTips" :key="i">{{ i + 1 }}. {{ tip }}</p>
                            </b-modal>
                    </div>
                </div>
			</div>
			<div class="col-lg-12">
				<div class="d-flex justify-content-center" style="height:150%">
					<input ref="cursor" type="text" class="form-control w-25 h-100 text-center rounded-pill" placeholder="분석할 키워드" v-model="targetKeyword" @keyup.enter="searchenter($event)">
					<div class="d-flex justify-content-center align-items-center ml-4">
						<button type="button" class="btn btn-primary" @click="search">카테고리심층분석</button>
					</div>
				</div>
			</div>
			<div class="col-lg-12 mt-5" v-if="showspinner">
				<div class="custom-control custom-control-inline d-flex justify-content-center">
					<div class="row">
						<div class="col-12">
							<img style="max-width:50px;" :src="require('../../../assets/images/small/loading.gif')">
							<span>{{loadingtext}}... {{loadingrate}}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-12 mt-3" v-if="showlist" style="font-size:80%">
				<div class="d-flex justify-content-between align-items-center mb-3">
					<div>
						<span class="text-muted">총 {{ categoryList.length }}개의 카테고리</span>
					</div>
					<div>
						<button type="button" class="btn btn-outline-danger btn-sm mr-2" @click="deleteSelectedCategories">
							<i class="fa fa-trash"></i> 선택삭제
						</button>
						<button type="button" class="btn btn-outline-secondary btn-sm mr-2" @click="clearAllCategories">
							<i class="fa fa-trash-alt"></i> 전체삭제
						</button>
						<button type="button" class="btn btn-outline-success btn-sm" @click="download">
							<i class="fa fa-download"></i> 다운로드
						</button>
					</div>
				</div>
				<div class="table-responsive rounded mb-3">
                    <CDataTable
                        storage-key="categoryAnalysis" :headers="headers" :items="categoryList" v-model="tableSelectedItem" :show-select="true" itemKey="_id">
						<template v-slot:minPrice="{item}">
                            {{ item.minPrice ? Math.round(item.minPrice).toLocaleString() + '원' : '-' }}
                        </template>
						<template v-slot:maxPrice="{item}">
                            {{ item.maxPrice ? Math.round(item.maxPrice).toLocaleString() + '원' : '-' }}
                        </template>
						<template v-slot:avgPrice="{item}">
                            {{ item.avgPrice ? Math.round(item.avgPrice).toLocaleString() + '원' : '-' }}
                        </template>
						<template v-slot:avgViews="{item}">
                            {{ item.avgViews ? Math.round(item.avgViews).toLocaleString() : '-' }}
                        </template>
						<template v-slot:avgReviews="{item}">
                            {{ item.avgReviews ? Math.round(item.avgReviews).toLocaleString() : '-' }}
                        </template>
						<template v-slot:estimatedAvgSales="{item}">
                            {{ item.estimatedAvgSales ? Math.round(item.estimatedAvgSales).toLocaleString() + '원' : '-' }}
                        </template>
						<template v-slot:popularKeywords="{item}">
                            <div v-if="item.popularKeywords && Array.isArray(item.popularKeywords) && item.popularKeywords.length > 0"
								class="d-flex align-items-center" style="max-width: 300px;">
								<div class="flex-grow-1" style="display: flex; flex-wrap: wrap; gap: 4px;">
									<span v-for="(keyword, index) in item.popularKeywords" :key="index"
										class="badge badge-primary"
										style="font-size: 11px; padding: 4px 8px; white-space: nowrap;">
										{{ keyword }}
									</span>
								</div>
								<button type="button"
										class="btn btn-outline-secondary btn-sm ml-2"
										style="padding: 2px 6px; font-size: 10px; flex-shrink: 0;"
										@click="copyKeywords(item.popularKeywords)"
										title="키워드 복사">
									<i class="fa fa-copy"></i>
								</button>
							</div>
							<div v-else-if="item.popularKeywords && !Array.isArray(item.popularKeywords)"
								style="color: red; font-size: 10px;">
								데이터 형태 오류: {{ typeof item.popularKeywords }} - {{ item.popularKeywords }}
							</div>
							<span v-else>-</span>
                        </template>
                    </CDataTable>
				</div>
			</div>
		</div>
		<!-- Page end  -->
	</div>
</template>
<script>
import * as XLSX from 'xlsx';
import { EXT_COLLECT_TIPS } from '@/utils/extInstallSteps';
import CDataTable from "@/components/common/CDataTable";
import IndexedDBStore from '@/components/common/IndexedDB';

export default {
	name:'nomadCategoryAnalysis',
	components:{
        CDataTable
    },
	data(){
		return{
			collectTips: EXT_COLLECT_TIPS,
			targetKeyword:'',
			showspinner:false,
			showlist:false,
			loadingtext:'',
			loadingrate:'',
			categoryList:[],
			tableSelectedItem:[],
			db: null,
			headers:[
				{text:'카테고리', value:'category', align:'center', width:200, isSlot:false, sortable:true},
				{text:'최소가격', value:'minPrice', align:'center', width:100, isSlot:true, sortable:true},
				{text:'최대가격', value:'maxPrice', align:'center', width:100, isSlot:true, sortable:true},
				{text:'평균가격', value:'avgPrice', align:'center', width:100, isSlot:true, sortable:true},
				{text:'평균조회수', value:'avgViews', align:'center', width:100, isSlot:true, sortable:true},
				{text:'평균리뷰수', value:'avgReviews', align:'center', width:100, isSlot:true, sortable:true},
				{text:'예상매출', value:'estimatedAvgSales', align:'center', width:100, isSlot:true, sortable:true},
				{text:'인기키워드', value:'popularKeywords', align:'center', width:300, isSlot:true, sortable:false},
			]
		}
	},
	async created() {
		// IndexedDB 초기화 - categoryAnalysis 전용 스토어 사용
		this.db = new IndexedDBStore('couplustDB', 'categoryAnalysis');
		await this.db.initDB();

		// 저장된 카테고리 분석 결과 불러오기
		try {
			const savedCategoryList = await this.db.getAnalysisResults();
			if (savedCategoryList && savedCategoryList.length > 0) {
				this.categoryList = savedCategoryList;
				this.showlist = true;
			}
		} catch (error) {
			console.error('카테고리 분석 결과 불러오기 실패:', error);
		}
	},
	mounted(){
		this.messageEventHandler = async(event) => {
			if(event.data.res && event.data.res === 'categoryAnalysisStatus'){
                console.log(event.data.status);
				this.loadingtext = event.data.text;
				this.loadingrate = '(' + (event.data.status*100).toFixed(0) + "%)";
            }
            if(event.data.res && event.data.msg === 'getCategoryAnalysis'){
                console.log(event.data);
				if(!event.data.categories){
					alert('쿠팡wing의 로그인 상태를 다시 확인해주세요')
					return
				}

				this.loadingtext = '카테고리 상세 분석 중';
				this.loadingrate = "";
				this.showspinner = true;
				this.showlist = false;
				this.addlist(event.data)
            }
            if(event.data.res && event.data.msg === 'getCategoryStats'){
                console.log('카테고리 통계 수신:', event.data.categoryStats);
				if(event.data.categoryStats){
					this.updateCategoryStats(event.data.categoryStats);
				}
            }
        }
		window.addEventListener('message', this.messageEventHandler);
		this.startfocus();
	},
	beforeDestroy(){
		window.removeEventListener('message', this.messageEventHandler);
	},
	methods: {
		startfocus(){
			this.$nextTick(() => {
				this.$refs.cursor.focus();
			})
		},
		searchenter(event){
			if(event.keyCode == '13'){
				this.search();
			}
		},
		async addlist(data){
			this.categoryList = [];

			// 카테고리 데이터 처리
			for(let i = 0; i < data.categories.length; i++){
				let category = data.categories[i];
				let categoryName = category.category.split(' > ').pop(); // 마지막 카테고리명만 추출

				let categoryItem = {
					_id: i,
					category: category.category,
					categoryId: category.categoryId,
					categoryCode: category.categoryCode,
					categoryName: categoryName,
					cnt: category.cnt,
					minPrice: 0,
					maxPrice: 0,
					avgPrice: 0,
					avgViews: 0,
					avgReviews: 0,
					estimatedAvgSales: 0,
					popularKeywords: []
				};

				this.categoryList.push(categoryItem);
			}

			// 각 카테고리에 대해 상세 분석 요청
			for(let i = 0; i < this.categoryList.length; i++){
				let item = this.categoryList[i];

				// 확장 프로그램에 상세 분석 요청
				window.postMessage({
					greeting: "getCategoryStats",
					categoryCode: item.categoryCode,
					categoryName: item.categoryName
				}, "*");

				// 진행률 업데이트
				this.loadingrate = '(' + ((i + 1) / this.categoryList.length * 100).toFixed(0) + "%)";

				// 잠시 대기 (API 호출 제한 방지)
				await new Promise(resolve => setTimeout(resolve, 1000));
			}

			this.showspinner = false;
			this.showlist = true;

			// 카테고리 분석 결과를 IndexedDB에 저장
			this.db.saveAnalysisResults(this.categoryList).catch(error => {
				console.error('카테고리 분석 결과 저장 실패:', error);
			});
		},
		updateCategoryStats(categoryStats){
			// 카테고리 통계 업데이트
			let categoryItem = this.categoryList.find(item =>
				item.categoryCode == categoryStats.categoryCode
			);

			if(categoryItem){
				categoryItem.minPrice = categoryStats.minPrice || 0;
				categoryItem.maxPrice = categoryStats.maxPrice || 0;
				categoryItem.avgPrice = categoryStats.avgPrice || 0;
				categoryItem.avgViews = categoryStats.avgViews || 0;
				categoryItem.avgReviews = categoryStats.avgReviews || 0;
				categoryItem.estimatedAvgSales = categoryStats.estimatedAvgSales || 0;

				// 연관키워드가 있는 경우 인기키워드로 추가
				if(categoryStats.relatedKeywords) {
					console.log('받은 relatedKeywords:', categoryStats.relatedKeywords, 'Type:', typeof categoryStats.relatedKeywords);

					if(Array.isArray(categoryStats.relatedKeywords)) {
						categoryItem.popularKeywords = categoryStats.relatedKeywords;
					} else if(typeof categoryStats.relatedKeywords === 'string') {
						// 문자열인 경우 콤마로 분리하여 배열로 변환
						categoryItem.popularKeywords = categoryStats.relatedKeywords.split(',').map(keyword => keyword.trim()).filter(keyword => keyword.length > 0);
					} else {
						console.warn('relatedKeywords가 예상하지 못한 형태입니다:', categoryStats.relatedKeywords);
						categoryItem.popularKeywords = [];
					}

					console.log('최종 popularKeywords:', categoryItem.popularKeywords);
				}

				console.log('카테고리 통계 업데이트 완료:', categoryItem);

				// 업데이트된 데이터를 IndexedDB에 저장
				this.db.saveAnalysisResults(this.categoryList).catch(error => {
					console.error('카테고리 분석 결과 저장 실패:', error);
				});
			}
		},
		search(){
			if(!this.targetKeyword){
				alert('분석할 키워드를 입력해 주세요')
				return
			}
			window.postMessage({greeting: "getCategoryAnalysis",
				companyid: this.$store.state.companyid,
				suppliercode: this.$store.state.suppliercode,
				info : {
					keyword:this.targetKeyword
				},
			},"*",)

			this.loadingtext = '키워드 카테고리 수집 중';
			this.loadingrate = '';
			this.showspinner = true;
			this.showlist = false;
		},
		copyKeywords(keywords) {
			if (!keywords || keywords.length === 0) {
				alert('복사할 키워드가 없습니다.');
				return;
			}

			const keywordText = keywords.join(',');

			// 클립보드 API 사용 (모던 브라우저)
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(keywordText).then(() => {
					this.$bvToast.toast('키워드가 클립보드에 복사되었습니다.', {
						title: '복사 완료',
						variant: 'success',
						solid: true,
						autoHideDelay: 2000
					});
				}).catch(err => {
					console.error('클립보드 복사 실패:', err);
					this.fallbackCopyTextToClipboard(keywordText);
				});
			} else {
				// 폴백 방법 (구형 브라우저)
				this.fallbackCopyTextToClipboard(keywordText);
			}
		},
		fallbackCopyTextToClipboard(text) {
			const textArea = document.createElement("textarea");
			textArea.value = text;

			// 화면에서 숨기기
			textArea.style.top = "0";
			textArea.style.left = "0";
			textArea.style.position = "fixed";
			textArea.style.opacity = "0";

			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();

			try {
				const successful = document.execCommand('copy');
				if (successful) {
					alert('키워드가 클립보드에 복사되었습니다.');
				} else {
					alert('복사에 실패했습니다.');
				}
			} catch (err) {
				console.error('폴백 복사 실패:', err);
				alert('복사에 실패했습니다.');
			}

			document.body.removeChild(textArea);
		},
		deleteSelectedCategories() {
			if (this.tableSelectedItem.length === 0) {
				alert('삭제할 카테고리를 선택해주세요.');
				return;
			}

			if (confirm(`선택된 ${this.tableSelectedItem.length}개의 카테고리를 삭제하시겠습니까?`)) {
				// 선택된 항목들의 _id를 수집
				const selectedIds = this.tableSelectedItem.map(item => item._id);

				// 선택되지 않은 항목들만 남기기
				this.categoryList = this.categoryList.filter(item => !selectedIds.includes(item._id));

				// 선택 목록 초기화
				this.tableSelectedItem = [];

				// IndexedDB에 저장
				this.db.saveAnalysisResults(this.categoryList).catch(error => {
					console.error('카테고리 분석 결과 저장 실패:', error);
				});

				// 모든 항목이 삭제되면 목록 숨기기
				if (this.categoryList.length === 0) {
					this.showlist = false;
				}
			}
		},
		clearAllCategories() {
			if (this.categoryList.length === 0) {
				alert('삭제할 카테고리가 없습니다.');
				return;
			}

			if (confirm('모든 카테고리 분석 결과를 삭제하시겠습니까?')) {
				this.categoryList = [];
				this.tableSelectedItem = [];
				this.showlist = false;

				// IndexedDB에서도 삭제
				this.db.saveAnalysisResults([]).catch(error => {
					console.error('카테고리 분석 결과 삭제 실패:', error);
				});
			}
		},
		download() {
			let downloadItems = [];
			let fileName = "카테고리심층분석";

			// 선택된 항목이 있으면 선택된 항목만, 없으면 전체 다운로드
			if (this.tableSelectedItem.length > 0) {
				if (confirm(`선택된 ${this.tableSelectedItem.length}개의 카테고리를 다운로드 하시겠습니까?`)) {
					downloadItems = this.tableSelectedItem;
					fileName += "_선택항목";
				} else {
					return;
				}
			} else {
				if (confirm('전체 카테고리 분석 결과를 다운로드 하시겠습니까?')) {
					downloadItems = this.categoryList;
				} else {
					return;
				}
			}

			if (downloadItems.length === 0) {
				alert('다운로드할 데이터가 없습니다.');
				return;
			}

			console.log('다운로드 항목:', downloadItems);
			var arr = [];
			downloadItems.forEach(e => {
				var obj = {
					카테고리: e.category,
					최소가격: Math.round(e.minPrice),
					최대가격: Math.round(e.maxPrice),
					평균가격: Math.round(e.avgPrice),
					평균조회수: Math.round(e.avgViews),
					평균리뷰수: Math.round(e.avgReviews),
					예상매출: Math.round(e.estimatedAvgSales),
					인기키워드: e.popularKeywords && e.popularKeywords.length > 0 ? e.popularKeywords.join(', ') : ''
				}
				arr.push(obj)
			})

			function getToday(){
				var date = new Date();
				var year = date.getFullYear();
				var month = ("0" + (1 + date.getMonth())).slice(-2);
				var day = ("0" + date.getDate()).slice(-2);

				return year + month + day;
			}

			const ws = XLSX.utils.json_to_sheet(arr);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "카테고리심층분석");
			XLSX.writeFile(wb, fileName + "_" + getToday() + ".xlsx");
		}
	}
}
</script>
